module.exports = __webpack_public_path__ + "img/Z2.896ccd5b.png";